/* eslint-disable max-len */
export const inputsData = {
  name: {
    id: 'name', name: 'Name', type: 'text', placeholder: 'Your name',
  },
  email: {
    id: 'email', name: 'Email', type: 'email', placeholder: 'Your email',
  },
  phone: {
    id: 'phone', name: 'Phone number', type: 'string', placeholder: '+380  XX  XXX  XX  XX',
  },
  position: {
    id: 'position', name: 'Select your position', type: 'radio',
  },
  photo: {
    id: 'photo', name: 'Photo', type: 'file', placeholder: 'Upload your photo',
  },
};
